//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { Text } from 'platform-components';
import React from 'react';

interface Props {
    lessonMode: CLESSON_MODES;
}

export const AssignmentLessonTypePlaceholder = React.memo((props: Props) => {
    const { lessonMode } = props;

    return (
        <div className="assignment__lesson-mode-placeholder" data-mode={lessonMode}>
            <Text id={`assignLessonModal.lessonModes.mode.${lessonMode}`} />
        </div>
    );
});
